// extracted by mini-css-extract-plugin
export var icon = "_5z-1";
export var subtext = "_5z-0";